import pRetry from 'p-retry';
import type { Options } from 'p-retry';
import { syncLatestTypes } from '@wix/velo-site-types-syncer';
import { getTestOverrides } from '@wix/cli-test-overrides';
import { CliError, CliErrorCode } from '@wix/cli-error';

export class VeloTypesSyncClient {
  private readonly retryOptions: Options;

  constructor(
    private projectFolder: string,
    private getToken: () => Promise<string>
  ) {
    const { minRetryTimeout } = getTestOverrides();

    this.retryOptions = {
      retries: 3,
      minTimeout: minRetryTimeout,
      maxTimeout: 3 * 1000,
    };
  }

  syncLatestTypes = async () => {
    const token = await this.getToken();

    try {
      await pRetry(
        () =>
          syncLatestTypes(this.projectFolder, {
            getAppToken: () => token,
          }),
        this.retryOptions
      );
    } catch (e) {
      throw new CliError({
        code: CliErrorCode.FailedToSyncPagesTypes(),
        cause: e,
      });
    }
  };
}
